import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    loading: false
  },
  mutations: {
    initializeStore(state) {
      const user = localStorage.getItem("user");

      if (user !== null) {
        state.user = JSON.parse(user);
      }
    },
    setUserLogged(state, user) {
      localStorage.setItem("user", JSON.stringify(user));
      state.user = user;
    },
    clearState(state) {
      state.user = null;
    }
  },
  actions: {
    setUserLogged({ commit, state }, payload) {
      commit("setUserLogged", payload.loggedUser);
    },
    clearState({ commit, state }) {
      commit("clearState");
    }
  },
  getters: {
    getUserLogged: state => {
      const user: any = localStorage.getItem("user");
      const stored = localStorage.getItem("user") ? JSON.parse(user) : null;
      return state && state.user ? state.user : stored;
    }
  },
  modules: {}
});
